import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { generateNotificationKeyRequest } from 'config/requests/merchants';

type Props = {
  onSuccess: (data: AxiosResponse) => void;
};

type UseGenerateNotificationKeyResult = {
  generateNotificationKey: () => void;
};

export function useGenerateNotificationKey({ onSuccess }: Props): UseGenerateNotificationKeyResult {
  const { mutate: generateNotificationKey } = useMutation({
    mutationFn: generateNotificationKeyRequest,
    onSuccess,
  });

  return { generateNotificationKey };
}
